import { createClass as _createClass } from "\0rollupPluginModLoBabelHelpers.js";
import { defineProperty as _defineProperty } from "\0rollupPluginModLoBabelHelpers.js";
import { cclegacy as _cclegacy } from "cc";

_cclegacy._RF.push({}, "a6497RJqHNAvaA+plHYHPi5", "ResManager", undefined);

import { Prefab, log, resources, assetManager, Texture2D, isValid, SpriteFrame, error, SpriteAtlas, JsonAsset, AudioClip, director } from "cc";
import { E_EventType } from "../EnumBase";
import { App } from "./App";

var ResManager = /*#__PURE__*/function () {
  function ResManager() {
    _defineProperty(this, "_prefabLoading", new Map());

    _defineProperty(this, "_arrPreLoad", []);

    _defineProperty(this, "_arrLoad", []);

    _defineProperty(this, "_loadIndex", 0);

    _defineProperty(this, "_loadTotal", 0);

    _defineProperty(this, "_preLoadNum", 0);

    _defineProperty(this, "_loadNum", 0);
  }

  var _proto = ResManager.prototype;

  /**-----------------------------资源加载 ---------------------------- */
  _proto.preLoad = function preLoad() {
    this._arrPreLoad = [{
      isDir: true,
      type: AudioClip,
      path: "Music",
      typeName: "audioClip"
    }];
    this._arrLoad = [// {
    //     isDir: true,
    //     type: AudioClip,
    //     path: "Music"
    // },
    {
      isDir: true,
      type: Prefab,
      path: "Prefab/Collider",
      typeName: "prefab"
    }, {
      isDir: true,
      type: Prefab,
      path: "Prefab/Barrier",
      typeName: "prefab"
    }, {
      isDir: true,
      type: Prefab,
      path: "Prefab/Prop",
      typeName: "prefab"
    }, {
      isDir: true,
      type: Prefab,
      path: "Prefab/PS",
      typeName: "prefab"
    }, {
      isDir: false,
      type: Prefab,
      path: "Prefab/ui_colliderTip",
      typeName: "prefab"
    }, {
      isDir: false,
      type: Prefab,
      path: "Prefab/msgTip",
      typeName: "prefab"
    }, {
      isDir: false,
      type: Prefab,
      path: "Prefab/shopTip",
      typeName: "prefab"
    }, {
      isDir: false,
      type: Prefab,
      path: "Prefab/coin",
      typeName: "prefab"
    }];
    this._preLoadNum = this._arrPreLoad.length;
    this._loadNum = this._arrLoad.length;
    this._loadTotal = this._loadIndex = this._loadNum; //预下载资源

    this.preLoadItem();
    this.loadItem(this._arrLoad[0], this.load_call.bind(this));
  }
  /**预下载资源 */
  ;

  _proto.preLoadItem = function preLoadItem() {
    for (var i = 0; i < this._arrPreLoad.length; i++) {
      if (this._arrPreLoad[i].isDir) {
        resources.preloadDir(this._arrPreLoad[i].path, this._arrPreLoad[i].type);
      } else {
        resources.preload(this._arrPreLoad[i].path, this._arrPreLoad[i].type);
      }
    }
  }
  /**预加载 - 对象池 */
  ;

  _proto.loadItem = function loadItem(item, call) {
    var _this = this;

    if (item.isDir) {
      resources.loadDir(item.path, item.type, function (err, data) {
        if (err) {
          console.log(err);
        } else if (item.typeName == "prefab") {
          for (var i = 0; i < data.length; i++) {
            _this.handlePool(data[i]);
          }
        }

        if (call) call();
      });
    } else {
      resources.load(item.path, item.type, function (err, data) {
        if (err) {
          console.log(err);
        } else if (item.typeName == "prefab") {
          _this.handlePool(data);
        }

        if (call) call();
      });
    }
  };

  _proto.load_call = function load_call() {
    this._loadIndex--;
    App.EventMgr.handleEvent(E_EventType.Res_Load, (this._loadTotal - this._loadIndex) / this._loadTotal);

    if (this._loadIndex > 0) {
      this.loadItem(this._arrLoad[this._loadTotal - this._loadIndex], this.load_call.bind(this));
    }
  }
  /**预添加 pool */
  ;

  _proto.preAddPool = function preAddPool(dir, type) {
    var _this2 = this;

    if (App.PoolMgr.getItem(type)) return;
    App.ResMgr.getPfb(dir + type, this, function (prefab) {
      _this2.handlePool(prefab);
    });
  }
  /**预添加 pool 目录 */
  ;

  _proto.preAddPoolArr = function preAddPoolArr(dir) {
    var _this3 = this;

    resources.loadDir(dir, Prefab, function (err, data) {
      for (var i = 0; i < data.length; i++) {
        _this3.handlePool(data[i]);
      }
    });
  }
  /**添加至对象池 */
  ;

  _proto.handlePool = function handlePool(pfb) {
    if (pfb.data.name.indexOf("c_1_") != -1) {
      App.PoolMgr.addPool(pfb, 3);
    } else if (pfb.data.name.indexOf("c_2_") != -1) {
      App.PoolMgr.addPool(pfb, 3);
    } else if (pfb.data.name.indexOf("c_3_") != -1) {
      App.PoolMgr.addPool(pfb, 3);
    } else if (pfb.data.name.indexOf("c_4_") != -1) {
      App.PoolMgr.addPool(pfb, 3);
    } else if (pfb.data.name == "p_dove") {
      App.PoolMgr.addPool(pfb, 3);
    } else if (pfb.data.name == "b_rotate") {
      App.PoolMgr.addPool(pfb, 3);
    } else if (pfb.data.name == "ui_colliderTip") {
      App.PoolMgr.addPool(pfb, 3);
    } else if (pfb.data.name == "ps_doveFly") {
      App.PoolMgr.addPool(pfb, 3);
    } else if (pfb.data.name == "msgTip") {
      App.PoolMgr.addPool(pfb, 3);
    } else if (pfb.data.name == "shopTip") {
      App.PoolMgr.addPool(pfb, 3);
    } else if (pfb.data.name == "coin") {
      App.PoolMgr.addPool(pfb, 3);
    }
  }
  /**
   * 加载远程图片
   * @param sp 加载的精灵
   * @param path 远程路径 
   */
  ;

  _proto.loadRemoteImg = function loadRemoteImg(sp, path) {
    if (!sp || !path) {
      error("ps is null or path is null");
      return;
    }

    assetManager.loadRemote(path, function (err, imgAsset) {
      if (!err && sp && isValid(sp, true)) {
        var sf = new SpriteFrame();
        var tex = new Texture2D();
        tex.image = imgAsset;
        sf.texture = tex;
        sp.spriteFrame = sf;
      } else {
        error(err);
      }
    });
  }
  /**
   * 加载远程文本
   * @param url 远程资源文本路径
   * @param call 回调函数
   */
  ;

  _proto.loadRemoteFile = function loadRemoteFile(url, call) {
    assetManager.loadRemote(url, function (err, info) {
      if (err) {
        error(err);
      } else {
        call && call(info);
      }
    });
  }
  /**加载远程音频 */
  ;

  _proto.loadRemoteClip = function loadRemoteClip(url, call) {
    assetManager.loadRemote(url, function (err, audioClip) {
      if (err) {
        error(err);
      } else {
        call && call(audioClip);
      }
    });
  }
  /**绝对路径 加载设备存储资源（eg:相册） */
  ;

  _proto.loadLocalImg = function loadLocalImg(sp, path) {
    if (!sp || !path) {
      error("ps is null or path is null");
      return;
    }

    assetManager.loadRemote(path, function (err, imgAsset) {
      if (!err && sp && isValid(sp, true)) {
        var sf = new SpriteFrame();
        var tex = new Texture2D();
        tex.image = imgAsset;
        sf.texture = tex;
        sp.spriteFrame = sf;
      } else {
        error(err);
      }
    });
  }
  /**
   * 加载本地图片
   * @param sp 加载的精灵
   * @param path 本地路径, 会自动添加'/priteFrame';
   */
  ;

  _proto.loadSf = function loadSf(sp, path) {
    if (path.indexOf("/spriteFrame") == -1) {
      path += "/spriteFrame";
    }

    resources.load(path, SpriteFrame, function (err, sf) {
      if (!err && sp) {
        sp.spriteFrame = sf;
      } else {
        error("loadLocalImg error = ", err);
      }
    });
  }
  /**
   * 加载纹理
   * @param sp 加载的精灵
   * @param path 本地路径 , 会自动添加'/texture';
   */
  ;

  _proto.getTex = function getTex(path, call) {
    if (path.indexOf("/texture") == -1) {
      path += "/texture";
    }

    resources.load(path, Texture2D, function (err, tex) {
      if (!err) {
        call && call(tex);
      } else {
        error("loadLocalImg error = ", err);
      }
    });
  }
  /**
   * 加载图集中的精灵
   * @param sp 加载的精灵
   * @param path 本地路径
   * @param name 加载的图片名字
   */
  ;

  _proto.loadSfFromAtlas = function loadSfFromAtlas(sp, path, name) {
    if (!name) {// log("name is null");
    }

    resources.load(path, SpriteAtlas, function (err, sa) {
      if (!err && sp && isValid(sp, true)) {
        var aimSf = sa.getSpriteFrame(name);

        if (aimSf) {
          sp.spriteFrame = aimSf;
        } else {// log("loadLocalAtlasImg err.. name is not exti", name);
        }
      } else {// log("loadLocalAtlasImg error = ", err);
        }
    });
  }
  /**
   * 
   * @param path json路径
   * @param callBack 加载回调 
   */
  ;

  _proto.loadJson = function loadJson(path, callBack) {
    resources.load(path, JsonAsset, function (err, json) {
      if (!err) {
        if (callBack) callBack(json.json);
      } else {}
    });
  }
  /**
   * 请求预制
   * @param path 预制路径
   * @param callback 成功回调
   * @param context 上下文
   * @param force 是否强制加载
   */
  ;

  _proto.getPfb = function getPfb(path, context, callback, force) {
    var _this4 = this;

    if (force === void 0) {
      force = false;
    }

    if (path && !this._prefabLoading.get(path) || force) {
      if (!force) {
        this._prefabLoading.set(path, true);
      }

      resources.load(path, Prefab, function (err, prefab) {
        if (_this4._prefabLoading.get(path)) _this4._prefabLoading.set(path, false);

        if (!err) {
          callback.call(context, prefab);
        } else {
          error(err);
        }
      });
    }
  }
  /**--------------------------------bundle -------------------------------- */

  /**
   * 加载子包
   * @param path bundle路径 
   * @param call bundle加载回调
   * @param version 版本号（热更新使用）
   */
  ;

  _proto.loadBundle = function loadBundle(path, call, version) {
    if (version === void 0) {
      version = "";
    }

    /**
     * url(复用其他项目的bundle),
     * name(bundle名字)
     * path(原生平台： jsb.fileUtils.getWritablePath(), 
     *      微信小游戏 wx.env.USER_DATA_PATH, 
     *      eg: wx.env.USER_DATA_PATH + "pathToBundle/bundleName'")
     */
    assetManager.loadBundle(path, version ? {
      version: version
    } : null, function (err, bundle) {
      if (err) {
        error(err);
      } else {
        call && call(bundle);
      }
    });
  };

  _proto.releaseBundle = function releaseBundle(name, isReaseLoaded) {
    if (isReaseLoaded === void 0) {
      isReaseLoaded = false;
    }

    var bundle = this.getBundle(name);
    if (!bundle) return;

    if (isReaseLoaded) {
      bundle.releaseAll();
    }

    assetManager.removeBundle(bundle);
  }
  /**获取bundle， 加载后可获取 */
  ;

  _proto.getBundle = function getBundle(name) {
    return assetManager.getBundle(name);
  }
  /**
   * 加载资源目录
   * @param path 资源路径
   * @param call 加载回调
   * @param bundle 所属bundle
   * @param type ?加载类型
   */
  ;

  _proto.loadDir_bundle = function loadDir_bundle(path, call, bundle, type) {
    if (type === void 0) {
      type = null;
    }

    var callLoad = function callLoad(err, assets) {
      if (err) {
        log(err);
      } else {
        call && call(assets);
      }
    };

    if (type) {
      bundle.loadDir(path, type, callLoad);
    } else {
      bundle.loadDir(path, callLoad);
    }
  }
  /**
   * 请求预制
   * @param path 预制路径
   * @param callback 成功回调
   * @param context 上下文
   * @param force 是否强制加载
   */
  ;

  _proto.getPfb_bundle = function getPfb_bundle(path, context, callback, bundle, force) {
    var _this5 = this;

    if (force === void 0) {
      force = false;
    }

    if (path && !this._prefabLoading.get(path) || force) {
      if (!force) {
        this._prefabLoading.set(path, true);
      }

      bundle.load(path, Prefab, function (err, prefab) {
        if (_this5._prefabLoading.get(path)) _this5._prefabLoading.set(path, false);

        if (!err) {
          callback.call(context, prefab);
        } else {
          error(err);
        }
      });
    }
  }
  /**
   * 加载纹理
   * @param sp 加载的精灵
   * @param path 本地路径 , 会自动添加'/texture';
   */
  ;

  _proto.loadSf_bundle = function loadSf_bundle(sp, path, bundle) {
    if (path.indexOf("/texture") == -1) {
      path += "/texture";
    }

    bundle.load(path, SpriteFrame, function (err, tex) {
      if (!err && sp) {} else {
        error("loadLocalImg error = ", err);
      }
    });
  }
  /**
   * 加载纹理
   * @param sp 加载的精灵
   * @param path 本地路径 , 会自动添加'/texture';
   */
  ;

  _proto.loadTex_bundle = function loadTex_bundle(sp, path, bundle) {
    if (path.indexOf("/texture") == -1) {
      path += "/texture";
    }

    bundle.load(path, Texture2D, function (err, tex) {
      if (!err && sp) {} else {
        error("loadLocalImg error = ", err);
      }
    });
  };

  _proto.loadScene_bundle = function loadScene_bundle(name, bundle) {
    bundle.loadScene(name, function (err, scene) {
      if (err) {
        error(err);
      } else {
        director.runScene(scene);
      }
    });
  };

  _createClass(ResManager, null, [{
    key: "I",
    get: function get() {
      if (!ResManager._I) {
        ResManager._I = new ResManager();
      }

      return ResManager._I;
    } //正在加载的预制界面

  }]);

  return ResManager;
}();

_defineProperty(ResManager, "_I", null);

export { ResManager as default };

_cclegacy._RF.pop();